<template>
  <div class="app-container">
    <div class="filter-container" style="display: flex;flex-wrap: wrap;">
      <el-input v-model="listQuery.outer_order_id" placeholder="外卖订单号" class="filter-item" style="width: 200px;" clearable />

      <el-input v-model="listQuery.sms_phone" placeholder="手机号码" class="filter-item" style="width: 200px;" clearable />

      <el-input v-model="listQuery.device_name" placeholder="设备名称" class="filter-item" style="width: 200px;" clearable />

      <el-select v-model="listQuery.state" placeholder="投餐状态" class="filter-item" style="width: 140px" clearable>
        <el-option label="待确认投餐" :value="1"></el-option>
        <el-option label="已确认投餐" :value="2"></el-option>
        <el-option label="已取餐" :value="3"></el-option>
        <el-option label="已取消投餐" :value="4"></el-option>
      </el-select>

      <el-date-picker v-model="dateArr" type="daterange" value-format="yyyy-MM-dd" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" class="filter-item" style="display: flex;" clearable></el-date-picker>

      <el-button class="filter-item" type="primary" @click="handleFilter">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="外卖订单号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.outer_order_id }}
        </template>
      </el-table-column>

      <el-table-column label="手机号码" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.sms_phone }}
        </template>
      </el-table-column>

      <el-table-column label="AUV订单id" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_id }}
        </template>
      </el-table-column>

      <el-table-column label="设备id" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.device_id }}
        </template>
      </el-table-column>

      <el-table-column label="设备名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.device_name }}
        </template>
      </el-table-column>

      <el-table-column label="格子号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.cell_id }}
        </template>
      </el-table-column>

      <el-table-column label="格子号别名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.cell_alias }}
        </template>
      </el-table-column>

      <el-table-column label="取餐码" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.take_code }}
        </template>
      </el-table-column>

      <el-table-column label="配送员投餐" min-width="110" align="center">
        <template slot-scope="scope">
          <div style="display: flex;flex-direction:column;align-items:center;text-align:center;">
            <span>{{ scope.row.send_personnel ? scope.row.send_personnel.user.name : "--" }}</span>
            <span>{{ scope.row.send_personnel ? scope.row.send_personnel.user.phone : "--" }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="送达员投餐" min-width="110" align="center">
        <template slot-scope="scope">
          <div style="display: flex;flex-direction:column;align-items:center;text-align:center;">
            <span>{{ scope.row.transport_personnel ? scope.row.transport_personnel.user.name : "--" }}</span>
            <span>{{ scope.row.transport_personnel ? scope.row.transport_personnel.user.phone : "--" }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="投餐状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.state === 1">待确认投餐</el-tag>
          <el-tag type="primary" v-else-if="scope.row.state === 2">已确认投餐</el-tag>
          <el-tag type="success" v-else-if="scope.row.state === 3">已取餐</el-tag>
          <el-tag type="danger" v-else-if="scope.row.state === 4">已取消投餐</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="投餐时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="发送短信状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.sms_status === 0">未发送</el-tag>
          <el-tag type="success" v-else-if="scope.row.sms_status === 1">发送成功</el-tag>
          <el-tag type="danger" v-else-if="scope.row.sms_status === 2">发送失败</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="短信接收状态" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.sms_receive_status }}
        </template>
      </el-table-column>

      <el-table-column label="取餐时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.take_meal_time }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="handleSmsHandle(scope.row)" :disabled="scope.row.sms_handle === 1">处理</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        list: null,
        total: null,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 10,
          school_id: "",
          outer_order_id: "",
          sms_phone: "",
          device_name: "",
          state: "",
          start_date: "",
          end_date: "",
        },
        btnLoading: false,
        dateArr: null,
      };
    },
    created() {
      this.getList();
    },
    computed: {
      ...mapGetters(["schools","school_id","user"])
    },
    watch: {
      school_id(newVal, oldVal) {
        this.listQuery.school_id = newVal;
        this.getList();
      },
      dateArr(newVal, oldVal) {
        if (newVal) {
          this.listQuery.start_date = newVal[0];
          this.listQuery.end_date = newVal[1];
        } else {
          this.listQuery.start_date = "";
          this.listQuery.end_date = "";
        }
      },
    },
    methods: {
      getList() {
        this.listQuery.school_id = this.school_id;
        this.listLoading = true;
        request({
          url: "/api/backend/takeoutSideboardOrder/list",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.list = response.data.data;
          this.total = response.data.total;
          this.listLoading = false;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
      handleSmsHandle(row) {
        this.$confirm("确认继续该操作", "提示", {
          type: "warning"
        }).then(() => {
          request({
            url: "/api/backend/takeoutSideboardOrder/smsHandle",
            method: "post",
            data: {
              sideboard_order_no: row.sideboard_order_no
            }
          }).then(()=>{
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功"
            });
          })
        }).catch(() => {});
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
